import {$sflyBridge} from "../../lib/Global";

if (!window.$sflyAuth) {
    $sflyBridge.Loader.fetchCDNInfo("sfly-auth").then((serverPath) => {
        // Bootstrap Auth system if we are using the new user auth system
        if (!$sflyBridge.Loader.isScriptLoaded(serverPath + "/dist/sfly-auth.js")) {
            $sflyBridge.Loader.loadScript(serverPath + "/dist/bootstrap.js", () => {
                $sflyBridge.dispatch("Auth:Loaded", true);
            });
        }

    });
}
